<div class="emds"
     [ngClass]="{'required': isRequired(),
                 'showRequiredOnly' : showRequiredOnly,
                 'required-invalid': (!!form ? form?.submitted : formGroupSubmitted) && fileUploadControlFormControl?.invalid}">
  <mat-form-field appearance="outline" class="emds-find-control">
    <mat-chip-list #chipList [disabled]="disableChips || disabled" matPrefix>
        <mat-chip *ngFor="let chip of chips"
                  [removable]="true"
                  (removed)="removeFile(chip)">
          <div class="chip-name-container">
            {{chip.name}}
          </div>
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
    </mat-chip-list>
    <input
        #chipInput
        [matChipInputFor]="chipList"
        type="text"
        id="{{Id}}-text-input"
        disabled
        class="emds-find-control-text-input">
    <input class="file-input" #uploadInput type="file" [multiple]="maxFiles !== 1" onclick="value=null" [accept]="allowedExtensions" (change)="selectFiles($event)" />
    <mat-icon matSuffix class="emds-find-control-icon"
              [ngClass]="{'clickable': !disabled, 'disabled': disabled}"
              (click)="inputUpload()">search</mat-icon>
  </mat-form-field>
  <div class="incorrect-input"
       *ngIf="(!!form ? form?.submitted : formGroupSubmitted) && fileUploadControlFormControl?.invalid">
       {{(fileUploadControlDisplayName || 'File Upload') + ' is a required field' | translate}}
  </div>
</div>
